import React, { PureComponent } from 'react'
import { Redirect } from 'react-router-dom'
import MenuServiceContext from '@signal/core/menuService/Context'
import { getDefaultRedirect } from '@signal/core/menuService/utils'
import { UnauthorizedError } from '@signal/utils/errors'
import isRelativeUrl from '@signal/utils/isRelativeUrl'
import renderIf from '@signal/utils/renderIf'
import Unauthorized from '../Unauthorized'

class UnauthorizedErrorBoundary extends PureComponent {
  static getDerivedStateFromError(error) {
    if (error instanceof UnauthorizedError) {
      return {
        unauthorized: true
      }
    }
  }

  componentDidCatch(error) {
    if (!(error instanceof UnauthorizedError)) {
      throw error
    }
  }

  state = {
    unauthorized: false
  }

  render() {
    const { children } = this.props
    const { unauthorized } = this.state
    return renderIf(
      unauthorized,
      () => (
        <MenuServiceContext.Consumer>
          {({ response: serviceMenu }) => {
            if (serviceMenu) {
              const redirectUrl = getDefaultRedirect(serviceMenu)
              if (redirectUrl && !window.location.href.endsWith(redirectUrl)) {
                this.setState({
                  unauthorized: false
                })

                if (!isRelativeUrl(redirectUrl)) {
                  window.location.href = redirectUrl
                } else {
                  return <Redirect to={redirectUrl} />
                }
              }
            }

            return <Unauthorized />
          }}
        </MenuServiceContext.Consumer>
      ),
      () => children
    )
  }
}

export default UnauthorizedErrorBoundary
